import { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import Icon, { IconPropsT } from './Icon';

const ArrowUpIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        width="8"
        height="5"
        viewBox="0 0 8 5"
        fill={theme.colors.primary.variant7}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3.99996 4.5C3.88075 4.50474 3.76188 4.48429 3.65111 4.43998C3.54034 4.39567 3.44016 4.3285 3.3571 4.24286L1.1071 1.99929C0.987371 1.87884 0.920166 1.71591 0.920166 1.54607C0.920166 1.37624 0.987371 1.21331 1.1071 1.09286C1.16743 1.02446 1.24162 0.969672 1.32475 0.932146C1.40788 0.894621 1.49804 0.875214 1.58925 0.875214C1.68045 0.875214 1.77061 0.894621 1.85374 0.932146C1.93687 0.969672 2.01106 1.02446 2.07139 1.09286L3.90996 2.93143C3.92495 2.94699 3.94293 2.95936 3.96281 2.96781C3.98269 2.97626 4.00407 2.98061 4.02568 2.98061C4.04728 2.98061 4.06866 2.97626 4.08854 2.96781C4.10842 2.95936 4.1264 2.94699 4.14139 2.93143L5.92853 1.09286C5.98829 1.03261 6.0594 0.984782 6.13773 0.952145C6.21607 0.919508 6.3001 0.902705 6.38496 0.902705C6.46983 0.902705 6.55385 0.919508 6.63219 0.952145C6.71053 0.984782 6.78163 1.03261 6.84139 1.09286C6.96112 1.21331 7.02833 1.37624 7.02833 1.54607C7.02833 1.71591 6.96112 1.87884 6.84139 1.99929L4.64282 4.24286C4.55976 4.3285 4.45958 4.39567 4.34881 4.43998C4.23804 4.48429 4.11917 4.50474 3.99996 4.5Z" />
      </svg>
    </Icon>
  );
};

export default ArrowUpIcon;
